/**
 * This file is generated by the generate-components script. Do not edit directly.
 */
/* eslint-disable */
import { createIcon } from "../createIcon.tsx";
import { forwardRef, type Ref, type SVGProps } from "react";

const BulletIcon16 = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" ref={ref} {...props}><path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8" /></svg>);
const BulletIcon24 = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" ref={ref} {...props}><path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12" /></svg>);
const BulletIcon32 = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={32} height={32} viewBox="0 0 32 32" ref={ref} {...props}><path d="M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16" /></svg>);

export const BulletIcon = createIcon(BulletIcon16, BulletIcon24, BulletIcon32, "BulletIcon");